// import axios from 'axios';
export default {
  components: {},
  data() {
    return {
      radioValue: '2',
      searchValue: '',
      tableConfig: {
        indexColumn: true,
        columns: [
          {
            title: t('商品SKU'),
            key: 'ECODE'
          },
          {
            title: t('SPU名称'),
            key: 'PS_C_PRO_ENAME'
          },
          {
            title: t('规格'),
            key: 'SPEC'
          },
          {
            title: t('是否为赠品'),
            key: 'IS_GIFT'
          }
          // {
          //   key: 'skuEcode',
          //   title: t('条码'),
          // },
          // {
          //   key: 'spuEcode',
          //   title: t('SPU编码'),
          // },
          // {
          //   key: 'spuEname',
          //   title: t('SPU名称'),
          // },
          // {
          //   key: 'skuEname',
          //   title: t('SKU名称'), // SKU名称
          // },
          // {
          //   key: 'brandEname',
          //   title: '品牌',
          // },
          // {
          //   key: 'classifyEname',
          //   title: '商品分类',
          // }
        ],
        data: [],
        selectionData: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        isShowSelection: true, // 是否显示checkedbox
        highlightRow: true, // 高亮单选必须结合它
        multiple: false //false 单选
      },
      data: [],
      currentSkuEcode: '',
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$route.params.tableName == 'OC_B_VIPCOM_RETURN_PO' ? this.ok() : this.confirm();
            } // 按钮点击事件
          },
        ]
      },
    };
  },
  props: {
    componentData: {
      type: Object
    },
    idArray: {
      type: Array,
      defalut: () => [],
    }
  },
  mounted() {
    console.log('componentData:', this.componentData);
  },
  methods: {
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectionData = selection;
     },
    // 单击某一行时触发
    onRowClick(row) {
      this.currentSkuEcode = row.skuEcode
    },
    // 双击某行时触发
    onRowDblclick() { },
    // 分页change 事件
    pageChange(val) {
      console.log(val);
      this.tableConfig.current = val;
      this.search();
    },
    // 切换分页条数
    pageSizeChange(val) {
      console.log(val);
      this.tableConfig.pageSize = val;
      this.search();
    },
    tableDeleteDetail() { },
    // 搜索
    search() {
      // sku查询
      const self = this;
      // let data = {
      //   skuEcode: self.searchValue,
      //   size: this.tableConfig.pageSize || 10,
      //   current: this.tableConfig.current || 1,
      // }
      // axios({
      //   method: 'post',
      //   url: '/r3-ps/p/cs/ps/pro/v1/selectSkuProBySkuEcodeList',
      //   data,
      // }).then((res) => {
      //   self.tableConfig.data = res.data.data.records;
      //   self.tableConfig.total = res.data.data.total
      // })

      const data = {
        isBlur: 'N',
        psCSku: { ECODE: self.searchValue },
      };
      self.service.common.skuQuery(data).then(res => {
        if (res.data.code == 0) {
          // if (JSON.stringify(res.data.data) == '{}') {
          //   // 查询数据为空!
          //   this.$Message.warning(t('查询数据为空'));
          //   return;
          // }
          if (res.data.data.data.length == 0) {
            // 查询数据为空!
            this.$Message.warning(t('查询数据为空'));
            return;
          }

          res.data.data.data[0].IS_GIFT = res.data.data.data[0].IS_GIFT == '0' ? t('否') : t('是');
          if (this.tableConfig.multiple) {
            let exist = self.tableConfig.data.some(i => i.PS_C_PRO_ECODE == res.data.data.data[0].PS_C_PRO_ECODE)
            if (!exist) {
              self.tableConfig.data.push(res.data.data.data[0])
              this.searchValue = ''
            }
          } else {
            self.tableConfig.data = res.data.data.data;
          }
        } else {
          // sku查询失败!
          this.$Message.warning(t('sku查询失败'));
        }
      });
    },
    // 替换
    async confirm() {
      console.log('self.tableConfig.data:', this.tableConfig.data);
      const self = this;
      if (self.tableConfig.data.length == 0) {
        // sku不能为空!
        self.$Message.warning(t('sku不能为空！'));
        return;
      }
      const param = {
        ids: self.componentData.ids,
        sku_code: self.tableConfig.data[0].ECODE,
        itemId: self.componentData.itemId,
        type: 1
      };

      // self.loading = true;
      try {
        const { data: { code, message, data } } = await this.service.orderCenter.bathChangeGoods(param);
        if (code == 0) {
          self.$Message.success(message);
          if (self.componentData.list) {
            self.$parent.$parent.$parent.getData();
          } else {
            if (self.$parent.$parent.$parent.reloadCus) self.$parent.$parent.$parent.reloadCus();
            if (self.$parent.$parent.$parent.$parent.autoRefresh) self.$parent.$parent.$parent.$parent.autoRefresh();
          }
          self.$parent.$parent.closeConfirm();
        } else {
          self.$parent.$parent.closeConfirm();
          self.$Modal.confirm({
            title: message,
            width: 500,
            render: h => h('Table', {
                props: {
                  columns: [
                    {
                      title: t('提示信息'),
                      key: 'message'
                    }
                  ],
                  data
                }
              })
          });
        }
      } catch (error) {
        self.loading = false;
      }
      // if (!this.currentSkuEcode) {
      //   // 请选中一条单据!
      //   self.$Message.warning(t('请选择需要操作的单据！'));
      //   return;
      // }
      // console.log(this.componentData);
      // let params = {
      //   orderList: this.componentData.orderList,
      //   skuEcodes: [this.componentData.oldSuk, this.currentSkuEcode],
      //   spuIds: this.componentData.spuIds
      // }
      // this.btnConfig.buttons[1].disabled = true;
      // const { data: { code, message, data } } = await this.service.orderCenter.replaceOrderByPro(params);
      // setTimeout(() => {
      //   this.btnConfig.buttons[1].disabled = false;
      // }, 5000);
      // console.log(code, message, data);
      // if (code === 0) {
      //   self.$Message.success(message);
      //   self.$parent.$parent.closeConfirm();
      //   self.$parent.$parent.$parent.$parent.$parent.getDetailsData();
      // } else if (code === -1) {
      //   this.$Modal.confirm({
      //     title: "message",
      //     width: 500,
      //     className: 'ark-dialog',
      //     mask: true,
      //     render: h => h('div', {
      //     }, data[0].message)
      //   });
      // }
    },
    // 异常替换
    async ok() {
      if (this.tableConfig.selectionData.length == 0) {
        this.$Message.warning(t('请添加并选择替换商品！'));
        return;
      }
      const SOURCE_ITEM_IDS = this.componentData.ids
      const REPLACE_SKU_IDS = this.tableConfig.selectionData.map(i => i.skuId)
      const param = {
        SOURCE_ITEM_IDS,
        REPLACE_SKU_IDS,
      };
      try {
        const { data: { code, message, data } } = await this.service.orderCenter.replaceSku(param);
        if (code == 0) {
          this.$Message.success(message)
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.$children[1].refresh()
        }
      } finally {}
    }
  }
};
